import { ServiceSymbol } from '../Container';

export interface EditorOptions {
    action?: string;
    camera?: string;
    ui?: boolean;
    mode?: number;
    kiosk?: boolean;
    template?: string;
    elementId?: string;
}

export const EditorOptions = Object.assign(
    ServiceSymbol<EditorOptions>('EditorOptions'),
    {
        fromWindow(purge = true) {

            const params = new URLSearchParams(window.location.search);
            const action = params.get('action') ?? 'none';
            const camera = params.get('camera') ?? 'default';
            const ui = params.get('ui') !== '0';
            const mode = Number(params.get('mode'));
            const options = { ...Object.fromEntries(params.entries()), action, camera, ui, mode };

            // Remove params, action and camera from URL, but leave other parameters
            if (purge) {
                params.delete('action');
                params.delete('camera');
                params.delete('ui');
            }

            const count = Array.from(params.keys()).length;
            const query = !!count ? `?${params.toString()}` : '';
            window.history.replaceState({}, '', `${window.location.pathname}${query}`);

            return options as EditorOptions;
        }
    }
);


